/**
 * Erreurs du module Outbound
 */
import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const OUTBOUND_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.INSEE_COMPANIES_ERROR]: {
        messageKey: 'insee-error-while-searching',
        severity: 'error',
    },
    [ERROR_CODES.REGISTRY_SEARCH_INVALID_INPUT]: {
        messageKey: 'insee-error-while-searching',
        severity: 'warning',
    },
    [ERROR_CODES.REGISTRY_SEARCH_TIMEOUT]: {
        messageKey: 'service-temporarily-unavailable-please-try-again-later',
        severity: 'warning',
    },
    [ERROR_CODES.REGISTRY_SEARCH_UNAVAILABLE]: {
        messageKey: 'service-temporarily-unavailable-please-try-again-later',
        severity: 'error',
    },
    [ERROR_CODES.REGISTRY_SEARCH_TECHNICAL_ERROR]: {
        messageKey: 'an-error-occurred',
        severity: 'error',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_REQUIRED]: {
        messageKey: 'connected-account-required',
        severity: 'warning',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_SCOPE_MISSING]: {
        messageKey: 'connected-account-scope-missing',
        severity: 'warning',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_CONSENT_DENIED]: {
        messageKey: 'connected-account-consent-denied',
        severity: 'warning',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_ADMIN_CONSENT_REQUIRED]: {
        messageKey: 'connected-account-admin-consent-required',
        severity: 'warning',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_PROVIDER_POLICY_BLOCKED]: {
        messageKey: 'connected-account-provider-policy-blocked',
        severity: 'error',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_NEEDS_RECONNECT]: {
        messageKey: 'connected-account-needs-reconnect',
        severity: 'warning',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_OAUTH_STATE_INVALID]: {
        messageKey: 'connected-account-oauth-state-invalid',
        severity: 'error',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_MAILBOX_UNAVAILABLE]: {
        messageKey: 'connected-account-mailbox-unavailable',
        severity: 'warning',
    },
    [ERROR_CODES.CONNECTED_ACCOUNT_PROVIDER_CAPABILITY_UNAVAILABLE]: {
        messageKey: 'connected-account-provider-capability-unavailable',
        severity: 'error',
    },
};